import React from "react";

const PostTags = ({ post }) => {
  const tags = Array.isArray(post?.tags)
    ? post.tags
    : Array.isArray(post?.keywords)
      ? post.keywords
      : [post?.category, "Latest"].filter(Boolean);

  if (!tags.length) return null;

  return (
    <div className="mt-6 rounded-md border border-slate-200 bg-white p-5 shadow-sm">
      <p className="text-sm font-semibold uppercase text-gray-500">Topics</p>
      <ul className="mt-3 flex flex-wrap gap-2">
        {tags.map((tag) => (
          <li key={tag}>
            <a
              href={`/blog/tag/${String(tag).toLowerCase().replace(/\s+/g, "-")}/`}
              className="inline-flex items-center justify-center rounded-sm bg-[rgba(126,34,206,0.08)] px-3 py-1.5 text-sm font-semibold text-[rgb(126,34,206)] ring-1 ring-[rgba(126,34,206,0.16)] transition hover:bg-[rgba(126,34,206,0.12)]"
            >
              {tag}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PostTags;
